<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.partner.details.bulkEdit.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <label class="label mb-1">
          {{ 'pricing.partner.details.bulkEdit.validFrom' | translate }}
        </label>
        <input
          ngbDatepicker
          class="form-control"
          id="bulkValidFrom"
          [formControl]="validFromControl"
          appInputValidationStatus
          container="body"
          #validFromDatepicker="ngbDatepicker"
          [readonly]="true"
          [minDate]="momentToNgbDate(minDate)"
          [maxDate]="momentToNgbDate(maxDate)"
          [startDate]="momentToNgbDate(startDate)"
          [placeholder]="'serviceData.form.placeholders.dateFormat' | translate"
          (click)="validFromDatepicker.toggle()"
        />
      </div>
      <div class="col-10 col-md-7">
        <label class="label mb-1">
          {{ 'pricing.partner.details.bulkEdit.copyFromPartner' | translate }}
        </label>
        <app-partner-typeahead
          [control]="copyPartnerControl"
          [placeholder]="
            'pricing.partner.details.bulkEdit.copyFromPartnerPlaceholder'
              | translate
          "
          (partnerSelected)="onPartnerSelected($event)"
        ></app-partner-typeahead>
      </div>
      <div class="col-2 col-md-1 d-flex align-items-end">
        <button
          type="button"
          class="icon-btn icon-btn-lg"
          triggers="hover"
          placement="top bottom"
          container="body"
          data-cy="copy-country-prices-btn"
          [ngbTooltip]="
            'pricing.partner.details.bulkEdit.copyFromCountry'
              | translate: { country: pricingPartner()?.country }
          "
          [disabled]="copyingFromCountry() || !rows().length"
          (click)="copyFromCountry($event)"
        >
          <i class="fa-light fa-cube"></i>
        </button>
      </div>
    </div>
    @if (currencyMissing()) {
      <div class="notes mb-3">
        {{ 'pricing.partner.details.noCurrencyWarning' | translate }}
      </div>
    }
    @if (!rows().length) {
      <div class="notes">
        {{ 'pricing.partner.details.bulkEdit.empty' | translate }}
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-sm align-middle">
          <thead>
            <tr>
              <th scope="col">
                {{ 'pricing.partner.details.bulkEdit.bundle' | translate }}
              </th>
              <th scope="col">
                {{
                  'pricing.partner.details.bulkEdit.currentPrice' | translate
                }}
              </th>
              <th scope="col">
                {{ 'pricing.partner.details.bulkEdit.newPrice' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.bundleId) {
              <tr>
                <td>{{ row.name }}</td>
                <td>
                  @if (
                    row.currentPrice !== null && row.currentPrice !== undefined
                  ) {
                    {{ row.currentPrice }}
                  } @else {
                    <span class="text-danger">{{
                      'pricing.partner.details.missingPrice' | translate
                    }}</span>
                  }
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    [formControl]="row.priceControl"
                    [placeholder]="
                      'pricing.partner.details.placeholders.price' | translate
                    "
                    [attr.data-cy]="'bulk-price-input-' + row.bundleId"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-clear"
      (click)="modalRef.close()"
      data-cy="close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="submitDisabled()"
      (click)="save()"
      data-cy="save-btn"
    >
      {{ 'pricing.partner.details.bulkEdit.save' | translate }}
    </button>
  </div>
</div>
